export default {
  computed: {
    hasViewMerchantSettingsPermission() {
      return this.verifyAuth([this.$role.VIEW_MERCHANT_SETTINGS]);
    },
    hasEditMerchantSettingsPermission() {
      return this.verifyAuth([this.$role.EDIT_MERCHANT_SETTINGS]);
    },
    hasSetCustomFieldsPermission() {
      return this.verifyAuth([this.$role.SET_CUSTOM_FIELDS]);
    },
    hasSetLogoPermission() {
      return this.verifyAuth([this.$role.SET_LOGO]);
    },
    hasSetBannerPermission() {
      return this.verifyAuth([this.$role.SET_BANNER]);
    },
    isMerchantAdmin() {
      return this.$role.verify([this.$role.MERCHANT_ADMIN]);
    },
    authorized() {
      return this.$role.verify([
        this.$role.VIEW_MERCHANT_SETTINGS,
        this.$role.EDIT_MERCHANT_SETTINGS,
        this.$role.SET_CUSTOM_FIELDS,
        this.$role.SET_LOGO,
        this.$role.SET_BANNER,
        this.$role.MERCHANT_ADMIN
      ]);
    }
  },
  methods: {
    verifyAuth(groups) {
      return this.isMerchantAdmin || this.$role.verify(groups);
    }
  }
};
